import { useAuth } from '@/composables/useAuth';
import { isSpecialRank } from '@/utils/UserHelper';

export default defineNuxtPlugin(() => {
  const { currentUser } = useAuth();

  useRouter().beforeEach((to, from, next) => {
    if (isSpecialRank(currentUser.value) && to.path !== '/special-message') {
      return next('/special-message');
    }
    next();
  });
});
